import styled, {keyframes} from 'styled-components';

import {colors, font} from 'theme';

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: stretch;
    align-items: center;
`;

export const ModalTitleContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
`;

export const InternalProductHint = styled.div`
    color: ${colors.textSecondary};
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 50px;

    animation: ${opacity} 2s ease;
`;
